import catalogo from "../assets/catalogo.json";

// Valida nombre (solo letras, espacios, y al menos 2 caracteres)
export function validateNombre(nombre) {
    if (!nombre) return "El nombre es obligatorio";
    if (nombre.length < 2){
        return "El nombre debe tener al menos 2 caracteres";
    }
    if (!/^[A-Za-zÁÉÍÓÚÑáéíóúñ\s]{2,}$/.test(nombre)){
        return "El nombre solo puede contener letras y espacios";
    }
    return "";
}

// valida el estado del estudiante, es obligatorio y debe estar en el catálogo
export const validateEstado = (value) => {
  if (!value || value.trim() === "") {
    return "El estado es obligatorio.";
  }
  if (!catalogo.estados.includes(value)) {
    return "El estado seleccionado no es válido.";
  }
  return "";
};

// valida la carrera/departamento, es obligatorio y debe estar en el catálogo
export const validateDepartamento = (value) => {
  if (!value || value.trim() === "") {
    return "La carrera/departamento es obligatoria.";
  }
  if (!catalogo.departamentos.includes(value)) {
    return "La carrera seleccionada no es válida.";
  }
  return "";
};


// Valida email
export function validateEmail(contacto) {
  if (!contacto) return "El contacto es obligatorio";

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(contacto))
    return "El contacto debe ser un correo válido";

  return "";
}

// Valida teléfono (opcional, puede ser chileno o internacional)
export function validateTelefono(telefono) {
  if (!telefono) return ""; // Opcional: no es obligatorio

  // Limpia espacios y guiones
  const clean = telefono.replace(/\s|-/g, "");

  // Acepta formatos internacionales con +, paréntesis y dígitos (mínimo 8, máximo 15)
  const telefonoRegex = /^\+?[0-9()]{8,15}$/;

  if (!telefonoRegex.test(clean)) {
    return "El teléfono debe tener entre 8 y 15 dígitos y solo puede contener números, paréntesis o '+'";
  }

  return "";
}
